import athenaConfig from '../config';

export function launchedFromAthenanetUserProfile() {
  const { manageFactorValue, clientIdParam } = AthenanetUserProfileLaunchedParams();
  return !!(
    manageFactorValue === 'true' &&
    clientIdParam &&
    athenaConfig?.anetUserProfileClientId?.includes(clientIdParam)
  );
}

export function AthenanetUserProfileLaunchedParams() {
  const queryParams = new URLSearchParams(window.location.search);

  const manageFactorValue = queryParams.get('manageFactor');
  const clientIdParam = queryParams.get('clientId');
  return { manageFactorValue, clientIdParam };
}

export function sendNoticeToParentWindow() {
  if (window?.parent) {
    window.parent.postMessage('mfa factor enrolled from ohsw', athenaConfig.aOneBaseUrl);
  }
}
